import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <p className="font-heading text-[64px] font-extrabold leading-none tracking-tight text-background-300 md:text-[96px]">
          404
        </p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已被移除，或者链接地址有误。可以返回首页继续浏览影视作品与资讯。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-4-line text-base leading-none" />
            </span>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}